var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudButPlayLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .playline {\n        fill: none;\n        stroke: currentColor;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "playline",
    d: "M39.64,21.54L16.91,6.24c-2.77-1.86-6.49.12-6.49,3.46v30.6c0,3.33,3.72,5.32,6.49,3.46l22.73-15.3c2.45-1.65,2.45-5.26,0-6.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudButPlayLine);
export default __webpack_public_path__ + "static/media/cloud_but_play_line.3c675b1fc45d820210814f5737ea7700.svg";
export { ForwardRef as ReactComponent };